import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ToggleInput.css';

class ToggleInput extends Component {
  static defaultProps = {
    value: '',
    label: '',
    required: false,
    description: '',
    errorText: '',
    className: '',
  };
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange({ target: { checked } }) {
    const { id, onChange, onValidate } = this.props;
    // Toggles only have one callback, so invoke both change and validate here.
    onChange(id, checked);
    onValidate(id, checked);
  }
  render() {
    const {
      id, name, label, required, value, description, errorText, className,
    } = this.props;
    const validClass = errorText !== '' ? 'invalid' : '';

    return (
      <div className={`${className} switch-holder`}>
        <div className="switch">
          <label className="active" htmlFor={id}>
            <span className="text">{label}{required ? <span className="required">*</span> : null}</span>
            <input
              type="checkbox"
              checked={value === true}
              id={id}
              name={name}
              className={validClass}
              onChange={this.handleChange}
            />
            <span className="lever" />
          </label>
        </div>
        {errorText !== '' ? <div className="error-message">{errorText}</div> : null}
        {description !== '' ? <div className="field-description">{description}</div> : null}
      </div>
    );
  }
}

ToggleInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.bool,
  description: PropTypes.string,
  errorText: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

export default ToggleInput;



// WEBPACK FOOTER //
// ./src/components/formElements/ToggleInput.js